export default function FaqEditController($window, $stateParams, $state, faqService, NotificationService, UtilService, EDITOR_CONSTANTS) {
  var vm = this;
  vm.isLoading = false;

  vm.newFaq = {};
  vm.faqs = [];
  vm.orginalFaqs = [];
  vm.lang = $stateParams.language;
  vm.sectionToEdit = $stateParams.sectionToEdit;

  vm.languages = EDITOR_CONSTANTS.LANGUAGES;
  vm.categories = EDITOR_CONSTANTS.CATEGORIES;

  vm.sortableOptions = {
    stop: function() {
      if (sortOrderChanged()) {
        updateOrder();
      }
    },
  };

  vm.deleteFaq = deleteFaq;
  vm.updateFaq = updateFaq;
  vm.saveFaqs = saveFaqs;
  vm.goToFaq = goToFaq;

  init();

  function init() {
    getFaq();
  }

  function sortOrderChanged() {
    return !angular.equals(vm.faqs, vm.originalFaqs);
  }

  function getFaq() {
    enableLoading();
    faqService
      .getFaqs(vm.sectionToEdit, vm.lang)
      .then(function(res) {
        if (res.data) {
          vm.originalFaqs = res.data.faqDtos;
          angular.copy(vm.originalFaqs, vm.faqs);
        }
      })
      .catch(function() {
        NotificationService.error('Cannot get faqs.');
      })
      .finally(function() {
        disableLoading();
      });
  }

  function updateFaq(faq) {
    const confirmation = $window.confirm('the changes will affect the business center FAQ section. Are you sure you want to continue?');
    if (confirmation) {
      if (!faq.id) {
        prepareNewFaqForSave(faq);
      }
      setSortOrder();
      saveFaqs();
    }
  }

  function updateOrder() {
    setSortOrder();
    saveFaqs();
  }

  function saveFaqs() {
    enableLoading();
    faqService
      .updateFaq(vm.sectionToEdit, vm.lang, vm.faqs)
      .then(function() {
        NotificationService.success('Faq successfully updated');
      })
      .catch(function() {
        NotificationService.error('Cannot update faqs.');
      })
      .finally(function() {
        disableLoading();
        vm.newFaq = {};
        getFaq();
      });
  }

  function prepareNewFaqForSave(faq) {
    faq.active = false;
    vm.faqs.push(faq);
  }

  function deleteFaq(faq) {
    const confirmation = $window.confirm('Are you sure you want to delete this question?');
    if (confirmation) {
      enableLoading();
      UtilService.deleteElementById(vm.faqs, faq.id);
      faqService
        .updateFaq(vm.sectionToEdit, vm.lang, vm.faqs)
        .then(function() {
          NotificationService.success('FAQ deleted');
        })
        .catch(function() {
          NotificationService.error('Cannot delete faqs.');
        })
        .finally(function() {
          disableLoading();
        });
    }
  }

  function setSortOrder() {
    vm.faqs.forEach(function(faq, index) {
      faq.sortOrder = index;
    });
  }

  function goToFaq() {
    $state.transitionTo(
      $state.current,
      {
        sectionToEdit: vm.sectionToEdit,
        language: vm.lang,
      },
      { reload: true },
    );
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/content-editor/bc/faq/faq-edit.controller.js